import { IMedia } from 'modules/common/interfaces';

export const getFirstImage = <T extends IMedia>(media?: readonly T[]): T | undefined =>
  media?.find((item) => item.type !== 'video');
